import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { EditRequestPage } from "@/features/request/edit";

const editRequestSearchSchema = z.object({
  "internal-notes": z.boolean().optional(),
});

export const Route = createFileRoute(
  "/_auth/_app-shell/requests/$requestId/edit",
)({
  component: EditRequestPage,
  params: {
    parse: (rawParams) => ({ requestId: Number(rawParams["requestId"]) }),
  },
  validateSearch: editRequestSearchSchema,
});
